import { render, staticRenderFns } from "./UserHelpFAQCard.vue?vue&type=template&id=183d9802&scoped=true&functional=true&"
import script from "./UserHelpFAQCard.vue?vue&type=script&lang=ts&"
export * from "./UserHelpFAQCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpFAQCard.vue?vue&type=style&index=0&id=183d9802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "183d9802",
  null
  
)

export default component.exports